module.exports = __webpack_public_path__ + "static/img/pic-zhou2.37a5e73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/pic-zhou2.jpg
// module id = 963
// module chunks = 0